<template lang="pug">
div
  .topo.hidden-md-and-down
    img#logo(
      :src='image',
      :style="{'margin-top': isIcmBio ? '5px' : '', height: isIcmBio ? '50px' : '60px'}"
      alt='sicarf',
      name="logo",
      @click="goHome"
    )
    .cards
      .card-text Processos cadastrados até o momento
        br
        .card-total {{totalProcessos}}
  .topo.hidden-md-and-down.topo-menu
    el-menu(
      :default-active="getRoute",
      class="el-menu-demo",
      mode="horizontal",
      @select="handleSelect",
      :router="true",
    )
      el-menu-item(index="home") O {{SISTEMA}}
      el-menu-item(v-if="EXIBIR_COMO_BAIXAR", index="baixar") COMO BAIXAR
      el-menu-item(v-if="EXIBIR_COMO_ENVIAR",index="enviar") COMO ENVIAR
      el-menu-item(index="central") CENTRAL DO INTERESSADO
      el-submenu.submenu-externo(v-if="EXIBIR_CONSULTA.HEADER" index="consulta")
        template(slot="title") FAÇA SUA CONSULTA
        div
          el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.ACERVO_FUNDIARIO", index="acervoFundiario", :class="{'color-menu ': isMenuConsultaGeral}") ACERVO FUNDIÁRIO
          el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.AUTENTICIDADE", index="autenticidade", :class="{'color-menu ': isMenuConsultaAutenticidade}") AUTENTICIDADE
          el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.LEGISLACAO", index="consultaLegislacao", :class="{'color-menu ': isMenuLegislacao}") CONSULTE A LEGISLAÇÃO
          el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.PROCESSO", index="geral", :class="{'color-menu ': isMenuConsultaGeral}") CONSULTAR PROCESSO
          el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.MAPA", index="mapa", :class="{'color-menu ': isMenuConsultaMapa}") CONSULTE A LOCALIZAÇÃO DA ÁREA (MAPA)
          el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.PORTARIA_HOMOLOGACAO", index="portariaHomologacao", :class="{'color-menu ': isMenuPortaria}") PORTARIA DE HOMOLOGAÇÃO
          el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.TRANSPARENCIA", index="transparencia", :class="{'color-menu ': isMenuTransparencia}") TRANSPARÊNCIA
          el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.PUBLICACAO", index="publicacao", :class="{'color-menu ': isMenuConsultaPublicacao}") PUBLICAÇÃO
          el-menu-item.submenu-color-hover(v-if="isPara", @click="openPainelConflitos", :class="{'color-menu ': isMenuPainelConflitos}") PAINEL DE CONFLITOS
      el-menu-item(index="informacao") INFORMAÇÃO
      el-menu-item(v-if="EXIBIR_MANUAL_USUARIO", index="manualUsuario") MANUAL DO USUÁRIO
      el-menu-item(v-if="isAmapa && EXIBIR_SIMULAR_VTN", index="simularVtn") SIMULAR VTN
      el-menu-item(v-if="EXIBIR_CONSULTA.FALE_CONOSCO", @click="modalFaleConosco") FALE CONOSCO
      el-menu-item(v-if="EXIBIR_CREDENCIADOS", @click="goCadastroCredenciado") SEJA UM CREDENCIADO!
  .menu-sandwich.hidden-lg-and-up
    .header-sandwich
      //- criado este offset para alinhar a imagem ao meio
      .offset
      img(
        :src='image',
        alt='sicarf',
        name="logo",
        @click="goHome"
      )
      .structure-icon
        .position-icon(@click="abrirMenu")
          font-awesome-icon(icon="bars")
    .container-sandwich(:class="{'is-active-sandwich': isActiveSandwich}")
      .divider
      el-menu(
        :default-active="getRoute",
        class="el-menu-demo",
        mode="vertical",
        @select="handleSelect",
        :router="true",
        menu-trigger="click"
      )
        el-menu-item(index="home") O {{SISTEMA}}
        el-menu-item(index="baixar") COMO BAIXAR
        el-menu-item(index="enviar") COMO ENVIAR
        el-menu-item(index="central") CENTRAL DO INTERESSADO
        el-submenu.submenu-externo(v-if="EXIBIR_CONSULTA.HEADER" index="consulta")
          template(slot="title") FAÇA SUA CONSULTA
          div
            el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.ACERVO_FUNDIARIO", index="acervoFundiario", :class="{'color-menu ': isMenuConsultaGeral}") ACERVO FUNDIÁRIO
            el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.AUTENTICIDADE", index="autenticidade", :class="{'color-menu ': isMenuConsultaAutenticidade}") AUTENTICIDADE
            el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.LEGISLACAO", index="consultaLegislacao", :class="{'color-menu ': isMenuLegislacao}") CONSULTE A LEGISLAÇÃO
            el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.PROCESSO", index="geral", :class="{'color-menu ': isMenuConsultaGeral}") CONSULTAR PROCESSO
            el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.PORTARIA_HOMOLOGACAO", index="portariaHomologacao", :class="{'color-menu ': isMenuPortaria}") PORTARIA DE HOMOLOGAÇÃO
            el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.TRANSPARENCIA", index="transparencia", :class="{'color-menu ': isMenuTransparencia}") TRANSPARÊNCIA
            el-menu-item.submenu-color-hover(v-if="EXIBIR_CONSULTA.PUBLICACAO", index="painelConflitos", :class="{'color-menu ': isMenuConsultaPublicacao}") PUBLICAÇÃO
        el-menu-item(index="informacao") INFORMAÇÃO
        el-menu-item(v-if="EXIBIR_MANUAL_USUARIO", index="manualUsuario") MANUAL DO USUÁRIO
        el-menu-item(v-if="isAmapa && EXIBIR_SIMULAR_VTN", index="simularVtn") SIMULAR VTN
        el-menu-item(v-if="EXIBIR_CONSULTA.FALE_CONOSCO", @click="modalFaleConosco") FALE CONOSCO
        el-menu-item(v-if="EXIBIR_CREDENCIADOS", @click="goCadastroCredenciado") SEJA UM CREDENCIADO!
  app-modal.modalFaleConosco(
    v-if="showModal",
    :titulo="'Fale conosco'",
    @closeModal="closeModal",
    :width="700",
    :bodyStyle="{height: 'auto'}",
    :footerStyle="{display: 'flex', justifyContent: 'right'}",
    :responsive="false"
  )
    template(slot="body")
      p Quer entrar em contato para tirar dúvidas ou enviar sugestões?
      br
      p {{modalTexto}}
    template(slot="footer")
      div.buttons
        el-button.cancelarButton(@click="closeModal")
          i.fas.fa-times
          |  Cancelar
        el-button(type="primary",key="botao-confirma",@click="goToLogin")
          i.fas.fa-check
          |  Confirmar
</template>

<script>
import $ from 'jquery'
import { mapState, mapActions } from 'vuex'
import AppModal from '@/components/AppModal'

export default {
  components: {
    AppModal
  },

  data () {
    return {
      isActiveSandwich: false,
      image: require('../../../../assets/images/logo-' + process.env.ESTADO + '.png'),
      totalProcessos: 0,
      showModal: false,
      modalTexto: `Então fale conosco por meio de nosso atendimento on-line, basta fazer o login ou se ainda não for cadastrado
      no sistema, criar uma conta (é simples e rápido). Estamos sempre prontos para atendê-lo!`
    }
  },
  async mounted () {
    $('.el-main, .el-menu-item').click((event) => {
      if (this.isActiveSandwich) this.isActiveSandwich = false
    })

    this.$store.dispatch('processos/totalProcessos').then((total) => { // eslint-disable-line
      this.totalProcessos = total
    })
  },
  computed: {
    ...mapState({
      EXIBIR_CONSULTA: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_CONSULTA,
      SISTEMA: state => state.userInterface.dadosEstado.SISTEMA,
      EXIBIR_MANUAL_USUARIO: state => state.userInterface.dadosEstado.PUBLICO.MANUAL_USUARIO.EXIBIR,
      EXIBIR_CREDENCIADOS: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_CREDENCIADOS,
      EXIBIR_SIMULAR_VTN: state => state.userInterface.dadosEstado.PUBLICO.SIMULAR_VTN.EXIBIR,
      EXIBIR_COMO_BAIXAR: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_COMO_BAIXAR,
      EXIBIR_COMO_ENVIAR: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_COMO_ENVIAR
    }),

    isAmapa () {
      return process.env.ESTADO === 'ap'
    },

    isIcmBio () {
      return process.env.ESTADO === 'default'
    },

    isPara () {
      return process.env.ESTADO === 'pa'
    },

    getRoute () {
      if (Array.isArray(this.$route.name)) {
        return this.$route.name[0]
      } else if (this.$route.name === 'observacoesImportantes' ||
        this.$route.name === 'duvidasFrequentes' ||
        this.$route.name === 'documentosCadastro') {
        return 'informacao'
      } else if (this.$route.path.split('/')[1] === 'autenticidade') {
        return 'autenticidade'
      }
      return this.$route.name
    },
    isMenuConsultaGeral () {
      return this.$route.name === 'consultaGeral'
    },

    isMenuTransparencia () {
      return this.$route.name === 'transparencia'
    },

    isMenuPortaria () {
      return this.$route.name === 'portariaHomologacao'
    },

    isMenuLegislacao () {
      return this.$route.name === 'legislacao'
    },

    isMenuConsultaAutenticidade () {
      return this.$route.path.split('/')[1] === 'autenticidade'
    },

    isMenuConsultaPublicacao () {
      return this.$route.name === 'publicacao'
    },

    isMenuPainelConflitos () {
      return this.$route.name === 'painelConflitos'
    }
  },
  methods: {

    ...mapActions({
      hasEditalVigente: 'credenciado/hasEditalVigente'
    }),

    scrollToTop () {
      // Scroll para o topo
      $('.el-main').animate({
        scrollTop: 0
      }, 'slow')
    },

    openPainelConflitos () {
      window.open('https://arcgisportal.iterpa.pa.gov.br/portal/home/webmap/viewer.html?webmap=c42097f46ab0422eade4d9ee2ac45b6c')
    },

    abrirMenu () {
      this.isActiveSandwich = !this.isActiveSandwich
    },

    handleSelect (key, keyPath) {
      this.$store.dispatch('processos/totalProcessos').then((total) => { // eslint-disable-line
        this.totalProcessos = total
      })
      this.scrollToTop()

      this.$router.push({
        name: keyPath[keyPath.length - 1]
      })
    },
    goScrollTo () {
      const elmnt = document.getElementById('home')
      elmnt.scrollIntoView()
    },
    goHome () {
      this.isActiveSandwich = false

      this.scrollToTop()

      this.$router.push({
        name: 'home'
      })
    },
    modalFaleConosco () {
      this.showModal = true
    },
    goCadastroCredenciado () {
      window.location.href = `${process.env.URL_CREDENCIADOS}#/editais`
    },
    closeModal () {
      this.showModal = false
    },
    goToLogin () {
      this.$router.push({
        name: 'login'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';
.submenu-externo {
  margin-top: -1px;
}

.cards {
  padding-top: 5px;
  float: right;
}
.card-text {
  width: 200px;
  color: black;
  display: inline-block;
  font-size: 11px;
  height: 100%;
  text-align: center;
}
.card-total {
  padding-top: 5px;
  font-size: 21px;
  font-weight: bold;
  color: $--color-primary;
}
.el-menu--horizontal > .el-menu-item {
  color: $--border-color-light !important;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: $--border-color-light;
}

@media only screen and (min-width: 1200px) {
  .el-menu-item, /deep/ .el-submenu__title {
    font-size: 11px;
  }
}

@media only screen and (min-width: 1440px) {
  .el-menu-item, /deep/ .el-submenu__title {
    font-size: 14px;
  }
}

.header-content {
  width: 100%;
  z-index: 1001;
}
.topo {
  width: 100%;
  height: 60px;
  left: 0;
  align-items: center;
  padding: 0 2% 0 2%;
  justify-content: space-between;
  background-color: #ffffff;
  font-size: xx-large;

  #logo {
    height: 60px;
    width: auto;
    cursor: pointer;
  }
}

.topo-menu {
  background-color: $--color-primary;
}

@media only screen and (max-width: 1600px) {
  .topo-menu {
    display: flex;
    flex-wrap: nowrap;
  }
}

.el-menu {
  background-color: transparent !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus {
  background-color: transparent !important;
  color: $--color-primary;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none !important;
  color: $--color-primary;
}
.el-menu--horizontal > .el-menu-item {
  border-bottom: none !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  color: $--color-primary;
  border-bottom: none !important;
}

@media screen and (min-width: 1220px) {
  .topo {
    padding: 0 5% 0 5%;
  }
}

@media screen and (max-width: 11200px) {
  .menu-sandwich {
    z-index: 1001;
  }
}

@media screen and (min-width: 1440px) {
  .topo {
    padding: 0 5% 0 5%;
  }
}

// menu sandwich

.menu-sandwich {
  width: 100%;
  height: 60px;
  position: fixed;
  left: 0;
  background-color: #f3f7fa;

  .header-sandwich {
    display: flex;
    justify-content: space-between;

    img {
      height: 60px;
    }

    .structure-icon {
      position: relative;

      .position-icon {
        position: absolute;
        top: 14px;
        right: 40px;

        i {
          font-size: 30px;
          cursor: pointer;

          &:hover {
            color: $--color-primary;
          }
        }
      }
    }
  }

  .container-sandwich {
    max-width: 100%;
    overflow: scroll;
    max-height: 0px;
    transition: max-height 0.5s cubic-bezier(0.46, 0.05, 0.71, 0.89);
    background-color: #f3f7fa;

    &.is-active-sandwich {
      max-height: 500px;
    }

    .divider {
      width: 100%;
      border-top: 1px #909399 solid;
    }

    /deep/ .el-menu {
      /deep/ .el-menu-item {
        padding-left: 20px !important;
        font-weight: normal;
      }

      /deep/ .el-submenu {
        font-weight: bold;
        /deep/ .el-menu-item {
          background-color: #f3f7fa;
          padding-left: 40px !important;
          font-size: 13px;
          font-weight: normal;
        }
      }
    }
  }
}

>>> .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent !important;
  color: white !important;
}
>>> .el-menu--horizontal > .el-submenu .el-submenu__title:active {
  color: white !important;
}
>>> .el-menu--horizontal > .el-submenu .el-submenu__title {
  color: white;
}
>>> .el-submenu__title i {
  color: white;
}
>>> .el-menu--horizontal > .el-submenu:focus .el-submenu__title,
>>> .el-menu--horizontal > .el-submenu:hover .el-submenu__title {
  color: white !important;
}
.color-menu {
  color: #009f61 !important;
}
>>> .el-menu--horizontal > .el-menu-item.is-active {
  color: white !important;
}

@media (max-width: 780px) {
  .modalFaleConosco {
    position: fixed !important;
    width: 410px !important;
  }

  .FaleConoscoButtons {
    background-color: #009f61;
    justify-content: space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/Header.vue